import React from 'react';

import { CardListItem, Button, ButtonProps } from '@opendoor/bricks/core';

import { InternalLink, InternalLinkProps } from 'platform/react-router';

type SubNavigationButton = ButtonProps & {
  type: 'button';
  analyticsName: string;
};

type SubNavigationInternalLink = Omit<InternalLinkProps, 'onClick'> & {
  type: 'internal-link';
  analyticsName: string;
};

export type SubNavigationCardProps = SubNavigationButton | SubNavigationInternalLink;

// component-test-check-ignore
/** TODO: Add documentation */
export const SubNavigationCard: React.FC<SubNavigationCardProps> = ({ children, ...props }) => {
  const analyticsName = `cake-subnav-${props.analyticsName}`;

  if (props.type === 'button') {
    return (
      <Button
        w="100%"
        color="neutrals100"
        _hover={{ color: 'neutrals100' }}
        {...props}
        analyticsName={analyticsName}
      >
        <CardListItem variant="secondary" color="neutrals100" height="100%">
          {children}
        </CardListItem>
      </Button>
    );
  }

  return (
    <InternalLink
      w="100%"
      color="neutrals100"
      _hover={{ color: 'neutrals100' }}
      {...props}
      analyticsName={analyticsName}
    >
      <CardListItem variant="secondary" color="neutrals100" height="100%">
        {children}
      </CardListItem>
    </InternalLink>
  );
};
